import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavComponent } from './side-nav.component';
import { LoadingSpinnerModule } from '@app/components/utils/loading-spinner.module';
import { OutsideClickModule } from '@app/_helpers/outside-click/outside-click.module';
import { BoundingBoxModule } from '../bounding-box/bounding-box.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@NgModule({
  declarations: [
    SideNavComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    CollapseModule.forRoot(),
    LoadingSpinnerModule,
    OutsideClickModule,
    BoundingBoxModule
  ],
  exports: [
    SideNavComponent
  ]
})
export class SideNavModule { }
